import React from 'react';
import './style.scss';
import { FiUpload } from 'react-icons/fi';
import { clientNetwork } from '../../lib/constants';
import { getUserData, userSession, authenticatedUserAddress } from '../../services/auth';
import { getNames } from '../../services/stacks';
import axios from 'axios';

function BannerUpload({ self, getInputProps, open, authorName, setErrorStates, setShowErrorModal }) {
    const handleOpen = async () => {
        if (!userSession.isUserSignedIn()) return;

        let userAddress = authenticatedUserAddress({ network: clientNetwork });
        console.log("p1 automagic networking: " + userAddress)

        const { success, names } = await getNames(userAddress);

        // Initialize error state
        let errors = {
            nameCheck: success && names.includes(authorName),
            zonefileCheck: false,
            storageCheck: false,
        };

        console.log('Initial Checks:', errors);

        // Check if user owns a name
        if (!errors.nameCheck) {
            setErrorStates(errors);
            setShowErrorModal(true);
            return;
        }

        // Check zonefile for the specified name
        try {
            const zonefileResponse = await axios.get(`https://api.hiro.so/v1/names/${authorName}/zonefile`);
            errors.zonefileCheck = !!zonefileResponse.data.zonefile;
            console.log('Zonefile Check:', errors.zonefileCheck);

            if (!errors.zonefileCheck) {
                setErrorStates(errors);
                setShowErrorModal(true);
                return;
            }

            // Extract and validate Profile.json from the zonefile
            const profileJsonUrl = extractProfileUrl(zonefileResponse.data.zonefile);
            if (!profileJsonUrl) {
                errors.storageCheck = false;
                setErrorStates(errors);
                setShowErrorModal(true);
                return;
            }

            const profileJson = await axios.get(profileJsonUrl);
            errors.storageCheck = validateStorageRecord(profileJson.data);
            console.log('Storage Record Check:', errors.storageCheck);

            // Check if all requirements are met before opening the banner upload
            if (errors.nameCheck && errors.zonefileCheck && errors.storageCheck) {
                open();
            } else {
                setErrorStates(errors);
                setShowErrorModal(true);
            }
        } catch (error) {
            console.error('Error during validation:', error);
            setErrorStates(errors);
            setShowErrorModal(true);
        }
    };

    // Function to extract Profile.json URL from the zonefile
    const extractProfileUrl = (zonefile) => {
        const match = zonefile.match(/\"(https:\/\/gaia.blockstack.org\/hub\/.+\/profile.json)\"/);
        return match ? match[1] : null;
    };

    // Function to validate the Storage Record relative to the App Origin
    const validateStorageRecord = (profile) => {
        const appOrigin = window.location.origin;
        return profile.appsMeta && profile.appsMeta[appOrigin];
    };

    return (
        <>
            {self && (
                <button id="upload-button" onClick={() => handleOpen()}>
                    <input hidden {...getInputProps()} />
                    <FiUpload id="bannerBtnIcon" fontSize="large" />
                </button>
            )}
        </>
    );
}

export default BannerUpload;
